import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CareerComponent } from './view/career/career.component';
import { CbseDisclosureComponent } from './view/cbse-disclosure/cbse-disclosure.component';
import { ContactUsComponent } from './view/contact-us/contact-us.component';
import { FaqComponent } from './view/faq/faq.component';
import { HomeComponent } from './view/home/home.component';
import { KindergartenComponent } from './view/kindergarten/kindergarten.component';
import { TransferCertificateComponent } from './view/transfer-certificate/transfer-certificate.component';


const routes: Routes = [
  {path:'',component:HomeComponent},
  {path:'career',component:CareerComponent},
  {path:'contact-us',component:ContactUsComponent},
  {path:'kindergarten',component:KindergartenComponent},
  {path:'cbse-disclosure',component:CbseDisclosureComponent},
  {path:'transfer-certificate',component:TransferCertificateComponent},
  {path:'about',loadChildren:'./modules/about/about.module#AboutModule'},
  {path:'blogs', loadChildren:'./modules/blogs/blogs.module#BlogsModule'},
  {path:'rules',loadChildren:'./modules/rules/rules.module#RulesModule'},
  {path:'infra',loadChildren:'./modules/infra/infra.module#InfraModule'},
  {path:'calendar',loadChildren:'./modules/calendar/calendar.module#CalendarModule'},
  {path:'achievers',loadChildren:'./modules/achievers/achievers.module#AchieversModule'},
  {path:'admission',loadChildren:'./modules/admission/admission.module#AdmissionModule'},
  {path:'gallery',loadChildren:'./modules/gallery/gallery.module#GalleryModule'},
  {path:'life',loadChildren:'./modules/life/life.module#LifeModule'},
  // {path:'life',loadChildren:'./modules/life/life.module#LifeModule'},
  {path:'video-gallery',loadChildren:'./modules/video/video.module#VideoModule'},
  {path:'media',loadChildren:'./modules/media/media.module#MediaModule'},
  {path:'testimonial',loadChildren:'./modules/testimonial/testimonial.module#TestimonialModule'},
  {path:'faq',component:FaqComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
